import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  importTimeKeepingStart,
  importTimeKeepingSuccess,
  importTimeKeepingFailed,
} from "../redux/importTimeKeeping";

import { SCREEN } from "helper/roleChecker/Screens";
import { formInputImportSelector } from "../redux/selector";
import { importTimeKeepingApi } from "core/http/service/timeKeeping";
import { toast } from "react-toastify";
import moment from "moment";

function* importTimeKeepingWork(action) {
  const form = yield select(formInputImportSelector);
  try {
    const month = moment(form?.monthSelected).month() + 1;
    const year = moment(form?.monthSelected).year();
    const formData = new FormData();
    formData.append("file", form?.file_files[0]);
    const res = yield call(importTimeKeepingApi, SCREEN.IP_021, formData, {
      month,
      year,
    });
    if (res?.type === "text/xml") {
      const url = URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Loi_import_${moment().format("DD/MM/YYYY")}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.warning("Dữ liệu trong tệp sai định dạng, đã tải file error");
      toast.error("Import tệp thất bại");
      yield put({
        type: importTimeKeepingFailed.type,
      });
    } else {
      yield put({
        type: importTimeKeepingSuccess.type,
      });
      action?.payload?.();
      toast.success("Import thành công");
    }
  } catch (error: any) {
    yield put({
      type: importTimeKeepingFailed.type,
    });
    toast.error("Đã có lỗi xảy ra");
  }
}

function* watchImportTimeKeeping() {
  yield takeLatest(importTimeKeepingStart.type, importTimeKeepingWork);
}

export default function* importTimeKeepingSaga() {
  yield all([watchImportTimeKeeping()]);
}
